var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-date-time"},[_c('i',{staticClass:"far fa-calendar-alt"}),_vm._v(" "+_vm._s(_vm.dateTime)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }